import React from "react";
import { useModal } from "../../context/ModalContext";

const ModalIframe = ({ data }) => {
  const { closeModal } = useModal();
  const title = data?.title || "";
  const url = data?.url || "";

  return (
    <div className="ModalIframe" style={{ backgroundColor: "#F9F6F0", borderRadius: "12px", overflow: "hidden" }}>
      <div className="container-fluid py-3">
        <div className="row justify-content-between align-items-center">
          <div className="col">
            <h4 className="m-0 text-uppercase"><strong>{title}</strong></h4>
          </div>
          <div className="col-auto">
            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
          </div>
        </div>
      </div>
      <div className="w-100" style={{ height: "75vh", overflow: "hidden" }}>
        <iframe src={url} width="100%" height="100%" style={{ border: "none" }} title={title} />
      </div>
    </div>
  );
};

export default ModalIframe;
